export default __webpack_public_path__ + "static/media/chigo-screenshot-06.5b4f6761.png";